import { RouterProvider } from "react-router-dom";
import "./App.css";
import { router } from "./routes/routes";
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
import { Toaster } from "react-hot-toast";


function App() {
  const queryClient = new QueryClient()
  return (
    <QueryClientProvider client={queryClient}>
      
      <RouterProvider router={router}>
      </RouterProvider>
      <Toaster />
    </QueryClientProvider>
  );
}

export default App;
